import React, { Component } from "react";
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn, FaYoutube} from "react-icons/fa";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/share/15SnoHLaBP/?mibextid=wwXIfr'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/dennis-isiakpona?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'},
    {Social: <FaYoutube />, link: 'https://youtube.com/@dennisogeisiakpona919?si=b3SuwX__wnDRCj1J'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/thea.q.u.i.l.a?igsh=MWx4bHlkbThlNXlteg%3D%3D&utm_source=qr'},
    {Social: <FaTwitter /> , link: 'https://x.com/_theaquila_?s=21'}
]

class Footer extends Component{
    constructor(props){
        super(props);
        this.state = {
            rnName: '',
            rnEmail: '',
        };
    }
    handleFormSubmit = (e) => {
        e.preventDefault(); // prevent default form reload
    
        const { rnName, rnEmail } = this.state;
    
        // Simple validation
        if (!rnName || !rnEmail) {
            alert("Please fill in both your name and email.");
            return;
        }
    
        // TODO: Replace with your backend API or service (e.g., Mailchimp)
        console.log("Form submitted with:", { rnName, rnEmail });
    
        // Reset form
        this.setState({ rnName: '', rnEmail: '' });
    
        // Optionally show a success message or toast
        alert("Thanks for subscribing!");
    };

    render(){

        return(
            <React.Fragment>
                <footer className="footer-area">
                    <div className="footer-wrapper">
                        <div className="row align-items-end row--0">
                            <div className="col-lg-6">
                                <div className="footer-left" style={{paddingLeft: "75px", paddingRight: "75px"}}>
                                    <div className="contact-form--1">
                                        <div className="section-title text-left mb--50">
                                            <h4 className="title">Stay in the Loop!</h4>
                                            <p className="description text-white">
                                                Sign up for exclusive content, emails, & things CoachDOI does not share anywhere else.
                                            </p>
                                        </div>
                                        <div className="form-wrapper">
                                            <form onSubmit={this.handleFormSubmit}>
                                                <label htmlFor="item01">
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        id="item01"
                                                        value={this.state.rnName}
                                                        onChange={(e)=>{this.setState({rnName: e.target.value});}}
                                                        placeholder="Your Name *"
                                                        style={{border: '1px solid #fff'}}
                                                    />
                                                </label>

                                                <label htmlFor="item02">
                                                    <input
                                                        type="text"
                                                        name="email"
                                                        id="item02"
                                                        value={this.state.rnEmail}
                                                        onChange={(e)=>{this.setState({rnEmail: e.target.value});}}
                                                        placeholder="Your email *"
                                                        style={{border: '1px solid #fff'}}
                                                    />
                                                </label>
                                                <button className="rn-button-style--2 btn-sm" type="submit" value="submit" name="submit" id="mc-embedded-subscribe">LET'S DO THIS</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="footer-right" data-black-overlay="6">
                                    <div className="row">
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12">
                                            <div className="footer-link">
                                                <h4>Quick Link</h4>
                                                <ul className="ft-link">
                                                    <li><a href="/">Home</a></li>
                                                    <li><a href="/about">About</a></li>
                                                    <li><a href="/contact">Let's Talk</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                                            <div className="footer-link">
                                                <h4>Say Hello</h4>
                                                {/* <ul className="ft-link">
                                                    <li><a href="mailto:books@coachdoi.com">books@coachdoi.com</a></li>
                                                    <li><a href="mailto:contact@coachdoi.com">contact@coachdoi.com</a></li>
                                                </ul> */}

                                                <div className="social-share-inner">
                                                    <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                                                        {SocialShare.map((val , i) => (
                                                            <li key={i}><a href={`${val.link}`} target="_blank">{val.Social}</a></li>
                                                        ))}
                                                    </ul>
                                                </div> 
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        <div className="col-lg-12">
                                            <div className="copyright-text">
                                                <p>Copyright © 2025 Dennis Isiakpona. All rights reserved.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;